import React, { useEffect, useState } from "react";
import {
  Avatar, Badge, Box, CardHeader, Chip, Divider, Grid, Paper, Tab,
  Tabs, Tooltip, Typography,
} from "@material-ui/core";
import {
  Cake as CakeIcon, Equalizer as DashBoardIcon, EventBusy as EventBusyIcon,
  Map as MapIcon, Redeem as RedeemIcon, Search as SearchIcon,
  SupervisedUserCircle as ClientesIcon, SwapVert as SwapVertIcon,
} from "@material-ui/icons";
import dayjs from "dayjs";
import NumberFormat from "react-number-format";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Container, DataGrid } from "src/components";
import { toUpper } from "src/helpers";
import {
  loadRankingAniversariantes, loadRankingCashback, loadRankingTransacoes,
  loadRankingVencimentos,
} from "src/store/actions/fidelidade_resumo";
import ModalCashbackPresente from "./ModalCashbackPresente";

function FidelidadeResumo({ width }) {
  const [tab, setTab] = useState(0);
  const [modal, setModal] = useState({ visible: false, usuario: {} });
  const [filtroCashback, setFiltroCashback] = useState({ top: 10 });
  const [filtroTransacoes, setFiltroTransacoes] = useState({ top: 10 });

  const [cashbackSubheader, setCashbackSubheader] = useState(
    "Top 10 clientes por Saldo"
  );
  const [transacoesSubheader, setTransacoesSubheader] = useState(
    "Top 10 clientes por número de transações"
  );

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const {
    loading,
    ranking_cashback,
    ranking_transacoes,
    ranking_vencimentos,
    ranking_aniversariantes,
  } = useSelector((state) => state.fidelidade_resumo);

  const { modulos } = useSelector((state) => state.menus);
  useEffect(() => handleTabChange(), [tab]);

  const handleTabChange = () => {
    switch (tab) {
      case 0:
        dispatch(loadRankingCashback(filtroCashback));
        setCashbackSubheader(`Top ${filtroCashback.top} clientes por saldo`);
        break;
      case 1:
        dispatch(loadRankingTransacoes(filtroTransacoes));
        setTransacoesSubheader(
          `Top ${filtroTransacoes.top} clientes por número de transações`
        );
        break;
      case 2:
        dispatch(loadRankingAniversariantes());
        break;
      case 3:
        dispatch(loadRankingVencimentos());
        break;
      default:
        break;
    }
  };

  const handleChipClick = (value) => {
    if (tab === 0) {
      setFiltroCashback({ ...filtroCashback, top: value });
      dispatch(loadRankingCashback({ ...filtroCashback, top: value }));
      setCashbackSubheader(`Top ${value} clientes por saldo`);
    } else {
      setFiltroTransacoes({ ...filtroTransacoes, top: value });
      dispatch(loadRankingTransacoes({ ...filtroTransacoes, top: value }));
      setTransacoesSubheader(`Top ${value} clientes por número de transações`);
    }
  };

  const handleCloseModal = () => setModal({ visible: false, usuario: null });

  const getData = () => {
    switch (tab) {
      case 0:
        return ranking_cashback;
      case 1:
        return ranking_transacoes;
      case 2:
        return ranking_aniversariantes;
      case 3:
        return ranking_vencimentos;
      default:
        break;
    }
  };

  const getCardHeader = () => {
    switch (tab) {
      case 0:
        return cashbackSubheader;
      case 1:
        return transacoesSubheader;
      case 2:
        return "Aniversariantes do mês";
      case 3:
        return "Cashbacks próximos de vencer";
      default:
        break;
    }
  };

  const getVariant = (value) => {
    switch (tab) {
      case 0:
        return filtroCashback.top === value ? "default" : "outlined";
      case 1:
        return filtroTransacoes.top === value ? "default" : "outlined";
      default:
        break;
    }
  };

  //Módulo de presente é o 5
  const verificaPermissaoPresente = () =>
    modulos.find((item) => (item.modulo_id === 5 ? true : false));

  return (
    <Container
      title="Resumo da empresa"
      buttonsRight={[
        {
          title: "Dashboard",
          icon: <DashBoardIcon />,
          onClick: () => navigate("/app/dashboard"),
        },
        {
          title: "Mapa",
          icon: <MapIcon />,
          onClick: () => navigate("/app/dashboard/mapa"),
        },
        {
          title: "Resumo",
          icon: <ClientesIcon />,
          onClick: () => navigate("/app/dashboard/resumo"),
          disabled: true,
        },
      ]}
    >
      <ModalCashbackPresente
        open={modal.visible}
        close={handleCloseModal}
        usuario={modal.usuario}
      />
      <Grid container spacing={2}>
        <Grid item md={12}>
          <Paper>
            <Divider />
            <Box display="flex">
              <CardHeader title={getCardHeader()} />
              <Tabs
                style={{ marginLeft: "auto" }}
                value={tab}
                indicatorColor="primary"
                textColor="primary"
                onChange={(e, value) => setTab(value)}
                variant="fullWidth"
              >
                <Tooltip title="Ranque de clientes por total de cashback">
                  <Tab icon={<SearchIcon />} style={{ maxWidth: 40 }} />
                </Tooltip>
                <Tooltip title="Ranque de clientes por ttde de transações">
                  <Tab icon={<SwapVertIcon />} style={{ maxWidth: 40 }} />
                </Tooltip>
                <Tooltip title="Aniversariantes do mês">
                  <Tab
                    icon={
                      <Badge color="primary">
                        <CakeIcon />
                      </Badge>
                    }
                    style={{ maxWidth: 40 }}
                  />
                </Tooltip>
                <Tooltip title="CashBacks vencendo">
                  <Tab icon={<EventBusyIcon />} style={{ maxWidth: 40 }} />
                </Tooltip>
              </Tabs>
            </Box>
            <Divider />
            {(tab === 0 || tab === 1) && (
              <Box
                display="flex"
                alignItems="center"
                padding="8px"
                margin="8px"
              >
                <Typography> Filtrar por top </Typography>
                <Chip
                  color="primary"
                  variant={getVariant(10)}
                  label="10"
                  onClick={() => handleChipClick(10)}
                  style={{ marginLeft: "4px" }}
                />
                <Chip
                  label="25"
                  color="primary"
                  variant={getVariant(25)}
                  onClick={() => handleChipClick(25)}
                  style={{ marginLeft: "4px" }}
                />
                <Chip
                  label="50"
                  color="primary"
                  variant={getVariant(50)}
                  onClick={() => handleChipClick(50)}
                  style={{ marginLeft: "4px" }}
                />
                <Chip
                  label="100"
                  color="primary"
                  variant={getVariant(100)}
                  onClick={() => handleChipClick(100)}
                />
              </Box>
            )}
            { tab === 2 ? (
              <DataGrid
                isLoading={loading}
                columns={[
                  { title: "", render: (data) => (
                    <Avatar alt={data.nome} src={`https://us-east-1.linodeobjects.com/images-conexo/fotos/${data.id }.png?=${new Date().getTime()}`} />
                    ), headerStyle: { paddingLeft: 10, width: 30 }, cellStyle: { paddingLeft: 10, width: 30 },
                  },
                  { title: "Nome", render: (data) => toUpper(data.nome), width: "auto", headerStyle: { paddingLeft: 10 }, cellStyle: { paddingLeft: 10 }},
                  { title: "Quantidade", field: "qtde", width: 30, headerStyle: { textAlign: "center" }, cellStyle: { textAlign: "center" }},
                  { title: "Saldo", render: (data) => (
                    <NumberFormat decimalScale={2} fixedDecimalScale={true} prefix={"R$ "} thousandSeparator={"."} decimalSeparator={","}
                      displayType={"text"} value={data.saldo || 0} />
                    ), width: 30, headerStyle: { textAlign: "center" }, cellStyle: { textAlign: "center" }, 
                  },
                  { title: "Aniversário", render: (data) => dayjs(data.nascimento).format("DD/MM"), 
                    width: 30, headerStyle: { textAlign: "center" }, cellStyle: { textAlign: "center" }, 
                  },
                ]}
                actions={
                  // verificaPermissaoPresente() &&
                  [{
                    icon: () => <RedeemIcon />,
                    tooltip: "Enviar cashback",
                    onClick: (event, rowData) => {
                      setModal({ visible: true, usuario: rowData });
                    },
                  }]
                }
                data={getData()}
              />
            ): tab == 3 ? (
              <DataGrid
                isLoading={loading}
                columns={[
                  { title: "", render: (data) => (
                      <Avatar alt={data.nome} src={`https://us-east-1.linodeobjects.com/images-conexo/fotos/${data.id }.png?=${new Date().getTime()}`} />
                    ), headerStyle: { paddingLeft: 10, width: 30 }, cellStyle: { paddingLeft: 10, width: 30 },
                  },
                  { title: "Nome", render: (data) => toUpper(data.nome), width: "auto", headerStyle: { paddingLeft: 10 }, cellStyle: { paddingLeft: 10 }},
                  { title: "Saldo Vencendo", render: (data) => (
                      <NumberFormat decimalScale={2} fixedDecimalScale={true} prefix={"R$ "} thousandSeparator={"."} decimalSeparator={","}
                        displayType={"text"} value={data.saldo_vencendo || 0} />
                    ), width: 30, headerStyle: { textAlign: "center" }, cellStyle: { textAlign: "center" }, 
                  },
                  { title: "Vencendo Em.", render: (data) => dayjs().add(parseInt(data.vencto_dias + 1), 'days').format("DD/MM/YYYY"), 
                    width: 30, headerStyle: { textAlign: "center" }, cellStyle: { textAlign: "center" }, 
                  },
                ]}
                data={getData()}
              />
            ):(
              <DataGrid
                isLoading={loading}
                columns={[
                  { title: "", render: (data) => (
                      <Avatar alt={data.nome} src={`https://us-east-1.linodeobjects.com/images-conexo/fotos/${data.id }.png?=${new Date().getTime()}`} />
                    ), headerStyle: { paddingLeft: 10, width: 30 }, cellStyle: { paddingLeft: 10, width: 30 },
                  },
                  { title: "Nome", render: (data) => toUpper(data.nome), width: "auto", headerStyle: { paddingLeft: 10 }, cellStyle: { paddingLeft: 10 }},
                  { title: "Quantidade", field: "qtde", width: 30, headerStyle: { textAlign: "center" }, cellStyle: { textAlign: "center" }},
                  { title: "Saldo", render: (data) => (
                      <NumberFormat decimalScale={2} fixedDecimalScale={true} prefix={"R$ "} thousandSeparator={"."} decimalSeparator={","}
                        displayType={"text"} value={data.saldo || 0} />
                    ), width: 30, headerStyle: { textAlign: "center" }, cellStyle: { textAlign: "center" }, 
                  },
                  { title: "Último cashback", render: (data) => dayjs(data.ultimo_cashback).format("DD/MM/YYYY"), 
                    width: 30, headerStyle: { textAlign: "center" }, cellStyle: { textAlign: "center" }, 
                  },
                ]}
                data={getData()}
              />
            )}
          </Paper>
        </Grid>
      </Grid>
    </Container>
  );
}

export default FidelidadeResumo;
